import { Language } from "../types";
export const languages: Language[] = [
	{
		code: "af",
		name: "Afrikaans",
		native: "Afrikaans",
		writing_system: "Latin",
	},
	{
		code: "am",
		name: "Amharic",
		native: "አማርኛ",
		writing_system: "Ethiopic",
	},
	{
		code: "ar",
		name: "Arabic",
		native: "العربية",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "as",
		name: "Assamese",
		native: "অসমীয়া",
		writing_system: "Bengali",
	},
	{
		code: "az",
		name: "Azerbaijani",
		native: "Azərbaycanca / آذربايجان",
		writing_system: "Latin",
	},
	{
		code: "ba",
		name: "Bashkir",
		native: "Башҡорт",
		writing_system: "Cyrillic",
	},
	{
		code: "be",
		name: "Belarusian",
		native: "Беларуская",
		writing_system: "Cyrillic",
	},
	{
		code: "bg",
		name: "Bulgarian",
		native: "Български",
		writing_system: "Cyrillic",
	},
	{
		code: "bn",
		name: "Bengali",
		native: "বাংলা",
		writing_system: "Bengali",
	},
	{
		code: "bo",
		name: "Tibetan",
		native: "བོད་ཡིག / Bod skad",
		writing_system: "Tibetan",
	},
	{
		code: "br",
		name: "Breton",
		native: "Brezhoneg",
		writing_system: "Latin",
	},
	{
		code: "bs",
		name: "Bosnian",
		native: "Bosanski",
		writing_system: "Latin",
	},
	{
		code: "ca",
		name: "Catalan",
		native: "Català",
		writing_system: "Latin",
	},
	{
		code: "ch",
		name: "Chamorro",
		native: "Chamoru",
		writing_system: "Latin",
	},
	{
		code: "co",
		name: "Corsican",
		native: "Corsu",
		writing_system: "Latin",
	},
	{
		code: "cs",
		name: "Czech",
		native: "Česky",
		writing_system: "Latin",
	},
	{
		code: "cy",
		name: "Welsh",
		native: "Cymraeg",
		writing_system: "Latin",
	},
	{
		code: "da",
		name: "Danish",
		native: "Dansk",
		writing_system: "Latin",
	},
	{
		code: "de",
		name: "German",
		native: "Deutsch",
		writing_system: "Latin",
	},
	{
		code: "dv",
		name: "Divehi",
		native: "ދިވެހިބަސް",
		rtl: 1,
		writing_system: "Thaana",
	},
	{
		code: "dz",
		name: "Dzongkha",
		native: "ཇོང་ཁ",
		writing_system: "Tibetan",
	},
	{
		code: "el",
		name: "Greek",
		native: "Ελληνικά",
		writing_system: "Greek",
	},
	{
		code: "en",
		name: "English",
		native: "English",
		writing_system: "Latin",
	},
	{
		code: "eo",
		name: "Esperanto",
		native: "Esperanto",
		writing_system: "Latin",
	},
	{
		code: "es",
		name: "Spanish",
		native: "Español",
		writing_system: "Latin",
	},
	{
		code: "et",
		name: "Estonian",
		native: "Eesti",
		writing_system: "Latin",
	},
	{
		code: "eu",
		name: "Basque",
		native: "Euskara",
		writing_system: "Latin",
	},
	{
		code: "fa",
		name: "Persian",
		native: "فارسی",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "ff",
		name: "Peul",
		native: "Fulfulde",
		writing_system: "Latin",
	},
	{
		code: "fi",
		name: "Finnish",
		native: "Suomi",
		writing_system: "Latin",
	},
	{
		code: "fj",
		name: "Fijian",
		native: "Na Vosa Vakaviti",
		writing_system: "Latin",
	},
	{
		code: "fo",
		name: "Faroese",
		native: "Føroyskt",
		writing_system: "Latin",
	},
	{
		code: "fr",
		name: "French",
		native: "Français",
		writing_system: "Latin",
	},
	{
		code: "fy",
		name: "West Frisian",
		native: "Frysk",
		writing_system: "Latin",
	},
	{
		code: "ga",
		name: "Irish",
		native: "Gaeilge",
		writing_system: "Latin",
	},
	{
		code: "gd",
		name: "Scottish Gaelic",
		native: "Gàidhlig",
		writing_system: "Latin",
	},
	{
		code: "gl",
		name: "Galician",
		native: "Galego",
		writing_system: "Latin",
	},
	{
		code: "gn",
		name: "Guarani",
		native: "Avañe'ẽ",
		writing_system: "Latin",
	},
	{
		code: "gu",
		name: "Gujarati",
		native: "ગુજરાતી",
		writing_system: "Gujarati",
	},
	{
		code: "gv",
		name: "Manx",
		native: "Gaelg",
		writing_system: "Latin",
	},
	{
		code: "ha",
		name: "Hausa",
		native: "هَوُسَ",
		rtl: 1,
		writing_system: "Latin",
	},
	{
		code: "he",
		name: "Hebrew",
		native: "עברית",
		rtl: 1,
		writing_system: "Hebrew",
	},
	{
		code: "hi",
		name: "Hindi",
		native: "हिन्दी",
		writing_system: "Devanagari",
	},
	{
		code: "hr",
		name: "Croatian",
		native: "Hrvatski",
		writing_system: "Latin",
	},
	{
		code: "ht",
		name: "Haitian",
		native: "Krèyol ayisyen",
		writing_system: "Latin",
	},
	{
		code: "hu",
		name: "Hungarian",
		native: "Magyar",
		writing_system: "Latin",
	},
	{
		code: "hy",
		name: "Armenian",
		native: "Հայերեն",
		writing_system: "Armenian",
	},
	{
		code: "id",
		name: "Indonesian",
		native: "Bahasa Indonesia",
		writing_system: "Latin",
	},
	{
		code: "ig",
		name: "Igbo",
		native: "Igbo",
		writing_system: "Latin",
	},
	{
		code: "is",
		name: "Icelandic",
		native: "Íslenska",
		writing_system: "Latin",
	},
	{
		code: "it",
		name: "Italian",
		native: "Italiano",
		writing_system: "Latin",
	},
	{
		code: "iu",
		name: "Inuktitut",
		native: "ᐃᓄᒃᑎᑐᑦ",
		writing_system: "Unified Canadian Aboriginal Syllabics",
	},
	{
		code: "ja",
		name: "Japanese",
		native: "日本語",
		writing_system: "Japanese",
	},
	{
		code: "jv",
		name: "Javanese",
		native: "Basa Jawa",
		writing_system: "Javanese",
	},
	{
		code: "ka",
		name: "Georgian",
		native: "ქართული",
		writing_system: "Georgian",
	},
	{
		code: "kg",
		name: "Kongo",
		native: "KiKongo",
		writing_system: "Latin",
	},
	{
		code: "ki",
		name: "Kikuyu",
		native: "Gĩkũyũ",
		writing_system: "Latin",
	},
	{
		code: "kj",
		name: "Kuanyama",
		native: "Kuanyama",
		writing_system: "Latin",
	},
	{
		code: "kk",
		name: "Kazakh",
		native: "Қазақша",
		writing_system: "Cyrillic",
	},
	{
		code: "kl",
		name: "Greenlandic",
		native: "Kalaallisut",
		writing_system: "Latin",
	},
	{
		code: "km",
		name: "Cambodian",
		native: "ភាសាខ្មែរ",
		writing_system: "Khmer",
	},
	{
		code: "kn",
		name: "Kannada",
		native: "ಕನ್ನಡ",
		writing_system: "Kannada",
	},
	{
		code: "ko",
		name: "Korean",
		native: "한국어",
		writing_system: "Korean",
	},
	{
		code: "kr",
		name: "Kanuri",
		native: "Kanuri",
		writing_system: "Latin",
	},
	{
		code: "ks",
		name: "Kashmiri",
		native: "कश्मीरी / كشميري",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "ku",
		name: "Kurdish",
		native: "Kurdî / كوردی",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "kv",
		name: "Komi",
		native: "Коми",
		writing_system: "Cyrillic",
	},
	{
		code: "kw",
		name: "Cornish",
		native: "Kernewek",
		writing_system: "Latin",
	},
	{
		code: "ky",
		name: "Kirghiz",
		native: "Kırgızca / Кыргызча",
		writing_system: "Cyrillic",
	},
	{
		code: "la",
		name: "Latin",
		native: "Latina",
		writing_system: "Latin",
	},
	{
		code: "lb",
		name: "Luxembourgish",
		native: "Lëtzebuergesch",
		writing_system: "Latin",
	},
	{
		code: "lg",
		name: "Ganda",
		native: "Luganda",
		writing_system: "Latin",
	},
	{
		code: "li",
		name: "Limburgian",
		native: "Limburgs",
		writing_system: "Latin",
	},
	{
		code: "ln",
		name: "Lingala",
		native: "Lingála",
		writing_system: "Latin",
	},
	{
		code: "lo",
		name: "Laotian",
		native: "ລາວ / Pha xa lao",
		writing_system: "Lao",
	},
	{
		code: "lt",
		name: "Lithuanian",
		native: "Lietuvių",
		writing_system: "Latin",
	},
	{
		code: "lu",
		name: "Luba-Katanga",
		native: "Tshiluba",
		writing_system: "Latin",
	},
	{
		code: "lv",
		name: "Latvian",
		native: "Latviešu",
		writing_system: "Latin",
	},
	{
		code: "mg",
		name: "Malagasy",
		native: "Malagasy",
		writing_system: "Latin",
	},
	{
		code: "mh",
		name: "Marshallese",
		native: "Kajin Majel / Ebon",
		writing_system: "Latin",
	},
	{
		code: "mi",
		name: "Maori",
		native: "Māori",
		writing_system: "Latin",
	},
	{
		code: "mk",
		name: "Macedonian",
		native: "Македонски",
		writing_system: "Cyrillic",
	},
	{
		code: "ml",
		name: "Malayalam",
		native: "മലയാളം",
		writing_system: "Malayalam",
	},
	{
		code: "mn",
		name: "Mongolian",
		native: "Монгол",
		writing_system: "Mongolian",
	},
	{
		code: "mo",
		name: "Moldovan",
		native: "Moldovenească",
		writing_system: "Latin",
	},
	{
		code: "mr",
		name: "Marathi",
		native: "मराठी",
		writing_system: "Devanagari",
	},
	{
		code: "ms",
		name: "Malay",
		native: "Bahasa Melayu",
		writing_system: "Latin",
	},
	{
		code: "mt",
		name: "Maltese",
		native: "bil-Malti",
		writing_system: "Latin",
	},
	{
		code: "my",
		name: "Burmese",
		native: "မြန်မာစာ",
		writing_system: "Myanmar",
	},
	{
		code: "na",
		name: "Nauruan",
		native: "Dorerin Naoero",
		writing_system: "Latin",
	},
	{
		code: "nb",
		name: "Norwegian Bokmål",
		native: "Norsk bokmål",
		writing_system: "Latin",
	},
	{
		code: "nd",
		name: "North Ndebele",
		native: "Sindebele",
		writing_system: "Latin",
	},
	{
		code: "ne",
		name: "Nepali",
		native: "नेपाली",
		writing_system: "Devanagari",
	},
	{
		code: "ng",
		name: "Ndonga",
		native: "Oshiwambo",
		writing_system: "Latin",
	},
	{
		code: "nl",
		name: "Dutch",
		native: "Nederlands",
		writing_system: "Latin",
	},
	{
		code: "nn",
		name: "Norwegian Nynorsk",
		native: "Norsk nynorsk",
		writing_system: "Latin",
	},
	{
		code: "no",
		name: "Norwegian",
		native: "Norsk",
		writing_system: "Latin",
	},
	{
		code: "nr",
		name: "South Ndebele",
		native: "isiNdebele",
		writing_system: "Latin",
	},
	{
		code: "nv",
		name: "Navajo",
		native: "Diné bizaad",
		writing_system: "Latin",
	},
	{
		code: "ny",
		name: "Chichewa",
		native: "Chi-Chewa",
		writing_system: "Latin",
	},
	{
		code: "oc",
		name: "Occitan",
		native: "Occitan",
		writing_system: "Latin",
	},
	{
		code: "oj",
		name: "Ojibwa",
		native: "ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin",
		writing_system: "Unified Canadian Aboriginal Syllabics",
	},
	{
		code: "om",
		name: "Oromo",
		native: "Oromoo",
		writing_system: "Latin",
	},
	{
		code: "or",
		name: "Oriya",
		native: "ଓଡ଼ିଆ",
		writing_system: "Odia",
	},
	{
		code: "os",
		name: "Ossetian / Ossetic",
		native: "Иронау",
		writing_system: "Cyrillic",
	},
	{
		code: "pa",
		name: "Panjabi / Punjabi",
		native: "ਪੰਜਾਬੀ / पंजाबी / پنجابي",
		writing_system: "Gurmukhi",
	},
	{
		code: "pi",
		name: "Pali",
		native: "Pāli / पाऴि",
		writing_system: "Devanagari",
	},
	{
		code: "pl",
		name: "Polish",
		native: "Polski",
		writing_system: "Latin",
	},
	{
		code: "ps",
		name: "Pashto",
		native: "پښتو",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "pt",
		name: "Portuguese",
		native: "Português",
		writing_system: "Latin",
	},
	{
		code: "qu",
		name: "Quechua",
		native: "Runa Simi",
		writing_system: "Latin",
	},
	{
		code: "rm",
		name: "Raeto Romance",
		native: "Rumantsch",
		writing_system: "Latin",
	},
	{
		code: "rn",
		name: "Kirundi",
		native: "Kirundi",
		writing_system: "Latin",
	},
	{
		code: "ro",
		name: "Romanian",
		native: "Română",
		writing_system: "Latin",
	},
	{
		code: "ru",
		name: "Russian",
		native: "Русский",
		writing_system: "Cyrillic",
	},
	{
		code: "rw",
		name: "Rwandi",
		native: "Kinyarwandi",
		writing_system: "Latin",
	},
	{
		code: "sa",
		name: "Sanskrit",
		native: "संस्कृतम्",
		writing_system: "Devanagari",
	},
	{
		code: "sc",
		name: "Sardinian",
		native: "Sardu",
		writing_system: "Latin",
	},
	{
		code: "sd",
		name: "Sindhi",
		native: "सिनधि",
		writing_system: "Arabic",
	},
	{
		code: "se",
		name: "Northern Sami",
		native: "Sámegiella",
		writing_system: "Latin",
	},
	{
		code: "sg",
		name: "Sango",
		native: "Sängö",
		writing_system: "Latin",
	},
	{
		code: "sh",
		name: "Serbo-Croatian",
		native: "Srpskohrvatski / Српскохрватски",
		writing_system: "Latin",
	},
	{
		code: "si",
		name: "Sinhalese",
		native: "සිංහල",
		writing_system: "Sinhala",
	},
	{
		code: "sk",
		name: "Slovak",
		native: "Slovenčina",
		writing_system: "Latin",
	},
	{
		code: "sl",
		name: "Slovenian",
		native: "Slovenščina",
		writing_system: "Latin",
	},
	{
		code: "sm",
		name: "Samoan",
		native: "Gagana Samoa",
		writing_system: "Latin",
	},
	{
		code: "sn",
		name: "Shona",
		native: "chiShona",
		writing_system: "Latin",
	},
	{
		code: "so",
		name: "Somalia",
		native: "Soomaaliga",
		writing_system: "Latin",
	},
	{
		code: "sq",
		name: "Albanian",
		native: "Shqip",
		writing_system: "Latin",
	},
	{
		code: "sr",
		name: "Serbian",
		native: "Српски",
		writing_system: "Cyrillic",
	},
	{
		code: "ss",
		name: "Swati",
		native: "SiSwati",
		writing_system: "Latin",
	},
	{
		code: "st",
		name: "Southern Sotho",
		native: "Sesotho",
		writing_system: "Latin",
	},
	{
		code: "su",
		name: "Sundanese",
		native: "Basa Sunda",
		writing_system: "Sundanese",
	},
	{
		code: "sv",
		name: "Swedish",
		native: "Svenska",
		writing_system: "Latin",
	},
	{
		code: "sw",
		name: "Swahili",
		native: "Kiswahili",
		writing_system: "Latin",
	},
	{
		code: "ta",
		name: "Tamil",
		native: "தமிழ்",
		writing_system: "Tamil",
	},
	{
		code: "te",
		name: "Telugu",
		native: "తెలుగు",
		writing_system: "Telugu",
	},
	{
		code: "tg",
		name: "Tajik",
		native: "Тоҷикӣ",
		writing_system: "Cyrillic",
	},
	{
		code: "th",
		name: "Thai",
		native: "ไทย / Phasa Thai",
		writing_system: "Thai",
	},
	{
		code: "ti",
		name: "Tigrinya",
		native: "ትግርኛ",
		writing_system: "Ethiopic",
	},
	{
		code: "tk",
		name: "Turkmen",
		native: "Туркмен / تركمن",
		writing_system: "Latin",
	},
	{
		code: "tl",
		name: "Tagalog / Filipino",
		native: "Tagalog",
		writing_system: "Latin",
	},
	{
		code: "tn",
		name: "Tswana",
		native: "Setswana",
		writing_system: "Latin",
	},
	{
		code: "to",
		name: "Tonga",
		native: "Lea Faka-Tonga",
		writing_system: "Latin",
	},
	{
		code: "tr",
		name: "Turkish",
		native: "Türkçe",
		writing_system: "Latin",
	},
	{
		code: "ts",
		name: "Tsonga",
		native: "Xitsonga",
		writing_system: "Latin",
	},
	{
		code: "tt",
		name: "Tatar",
		native: "Tatarça",
		writing_system: "Cyrillic",
	},
	{
		code: "tw",
		name: "Twi",
		native: "Twi",
		writing_system: "Latin",
	},
	{
		code: "ty",
		name: "Tahitian",
		native: "Reo Mā`ohi",
		writing_system: "Latin",
	},
	{
		code: "ug",
		name: "Uyghur",
		native: "Uyƣurqə / ئۇيغۇرچە",
		writing_system: "Arabic",
	},
	{
		code: "uk",
		name: "Ukrainian",
		native: "Українська",
		writing_system: "Cyrillic",
	},
	{
		code: "ur",
		name: "Urdu",
		native: "اردو",
		rtl: 1,
		writing_system: "Arabic",
	},
	{
		code: "uz",
		name: "Uzbek",
		native: "Ўзбек",
		writing_system: "Latin",
	},
	{
		code: "ve",
		name: "Venda",
		native: "Tshivenḓa",
		writing_system: "Latin",
	},
	{
		code: "vi",
		name: "Vietnamese",
		native: "Tiếng Việt",
		writing_system: "Latin",
	},
	{
		code: "vo",
		name: "Volapük",
		native: "Volapük",
		writing_system: "Latin",
	},
	{
		code: "wo",
		name: "Wolof",
		native: "Wollof",
		writing_system: "Latin",
	},
	{
		code: "xh",
		name: "Xhosa",
		native: "isiXhosa",
		writing_system: "Latin",
	},
	{
		code: "yi",
		name: "Yiddish",
		native: "ייִדיש",
		rtl: 1,
		writing_system: "Hebrew",
	},
	{
		code: "yo",
		name: "Yoruba",
		native: "Yorùbá",
		writing_system: "Latin",
	},
	{
		code: "zh",
		name: "Chinese (Simplified)",
		native: "简体中文",
		writing_system: "Simplied Han",
	},
	{
		code: "zh-TW",
		name: "Chinese (Traditional)",
		native: "繁體中文",
		writing_system: "Traditional Han",
	},
	{
		code: "zu",
		name: "Zulu",
		native: "isiZulu",
		writing_system: "Latin",
	},
];
